var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav-tabs"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#E3EAEF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Value"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.1479 26.3519L23.6273 22.8321C24.6477 21.6071 25.1566 20.0358 25.048 18.4451C24.9394 16.8545 24.2217 15.3669 23.0443 14.2919C21.8668 13.2169 20.3203 12.6373 18.7263 12.6735C17.1324 12.7097 15.6138 13.359 14.4864 14.4864C13.359 15.6138 12.7097 17.1324 12.6735 18.7263C12.6373 20.3203 13.2169 21.8668 14.2919 23.0443C15.3669 24.2217 16.8545 24.9394 18.4451 25.048C20.0358 25.1566 21.6071 24.6477 22.8321 23.6273L26.3519 27.1479C26.4042 27.2001 26.4663 27.2416 26.5345 27.2699C26.6028 27.2982 26.676 27.3127 26.7499 27.3127C26.8238 27.3127 26.897 27.2982 26.9653 27.2699C27.0336 27.2416 27.0956 27.2001 27.1479 27.1479C27.2001 27.0956 27.2416 27.0336 27.2699 26.9653C27.2982 26.897 27.3127 26.8238 27.3127 26.7499C27.3127 26.676 27.2982 26.6028 27.2699 26.5345C27.2416 26.4663 27.2001 26.4042 27.1479 26.3519ZM13.8124 18.8749C13.8124 17.8736 14.1093 16.8949 14.6656 16.0623C15.2219 15.2298 16.0125 14.5809 16.9376 14.1978C17.8626 13.8146 18.8805 13.7144 19.8626 13.9097C20.8446 14.105 21.7466 14.5872 22.4546 15.2952C23.1626 16.0032 23.6448 16.9052 23.8401 17.8873C24.0355 18.8693 23.9352 19.8872 23.5521 20.8123C23.1689 21.7373 22.52 22.528 21.6875 23.0842C20.855 23.6405 19.8762 23.9374 18.8749 23.9374C17.5327 23.9359 16.2459 23.4021 15.2968 22.453C14.3478 21.5039 13.8139 20.2171 13.8124 18.8749Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogo);
export default __webpack_public_path__ + "static/media/sidebar-logo.2de67ec730f5f45d897f8cb8cfe99beb.svg";
export { ForwardRef as ReactComponent };